module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_1.f8fd4711.png";